import { render } from "./Irregulares.vue?vue&type=template&id=0ec0918b&scoped=true"
import script from "./Irregulares.vue?vue&type=script&lang=js"
export * from "./Irregulares.vue?vue&type=script&lang=js"

import "./Irregulares.vue?vue&type=style&index=0&id=0ec0918b&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec0918b"]])

export default __exports__